<div class="custella-modal">

    <div class="custella-modal-header align-items-center">
        <div class="custella-modal-header-text">{{header | titlecase}} {{module | titlecase}}</div>
        <i class="pi pi-times" [pTooltip]="translate?.general?.buttons?.close.singular" tooltipPosition="left" (click)="modalRef.hide()"></i>
    </div>

    <div class="custella-modal-body">
        <div class="custella-form-container position-relative d-block w-100 rounded-2 box-none m-0">
            <h5 class="font-bold">{{title}}</h5>
            <p *ngIf="header == 'add' && !isNextButtonClicked && data?.nodeInfo">{{translate?.report.messages.folderCreatedIn}} {{currentFolder}}</p>
            <p *ngIf="header == 'rename' && !isNextButtonClicked">{{translate?.report.messages.folderCurrentlyIn}} {{currentFolder}}</p>

            <form [formGroup]="folderForm">
                <div *ngIf="!isNextButtonClicked && header !== 'share'">
                    <input pInputText formControlName="name" autocomplete="off" type="text" [placeholder]="translate?.report.messages.enterFolderNameHere" (keyup)="onFolderNameChange()" />
                    <div class="p-error text-10 mt-1" *ngIf="folderForm.controls['name'].touched && folderForm.controls['name'].invalid">
                        <span *ngIf="folderForm.controls['name'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        <span *ngIf="folderForm.controls['name'].errors?.maxlength">{{maxLengthErrorMssg}}</span>
                    </div>
                </div>
                <ng-container *ngIf="isNextButtonClicked || header == 'share'">
                    <!-- Step 1 -->
                    <div class="section-title">
                        <span class="bullet-container"><span class="font-white fa-sm number-bullet">1</span></span>
                        <h6 class="font-bold mt-2 bullet-label">{{translate?.report.messages.whichUsersToShareFile}} {{module}} {{translate?.report.messages.with}}</h6>
                        <i class="fa-regular fa-info-circle fa-sm" [pTooltip]="translate?.report.messages.whichUsersToShareFileHelpText"></i>
                    </div>
                    <div class="row-line">
                        <div class="grow">
                            <p-multiSelect class="w-100 reports-select" [options]="users" display="chip" 
                                optionLabel="fullName" optionValue="id" [maxSelectedLabels]="6"
                                formControlName="user" [placeholder]="translate?.report.messages.addUsersHere" optionDisabled="disabled"
                                id="picklist_viewerUsers" (onChange)="onUserChange($event)" [showToggleAll]="false"
                                (onPanelHide)="onDropdownHide(panelValue)"
                                #panelValue>

                                <!-- <ng-template let-value pTemplate="selectedItems">
                                    <ng-container *ngIf="value && value.length > 6; else showLabels">
                                    {{ value.length }} items selected
                                    </ng-container>
                                    <ng-template #showLabels>
                                    <span *ngFor="let v of value; last as isLast">
                                        {{ v.fullName }}<span *ngIf="!isLast">, </span>
                                    </span>
                                    </ng-template>
                                    <span *ngIf="!value || value.length === 0">Select items</span>
                                </ng-template> -->

                            </p-multiSelect>
                            <div class="p-error text-10 mt-1" *ngIf="folderForm.controls['user'].touched && folderForm.controls['user'].invalid">
                                <span *ngIf="folderForm.controls['user'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                            </div>
                        </div>
                      
                    </div>


                    <!-- List of Access -->
                    <div class="list-block" *ngIf="selected_users.length > 0">
                        <div class="list-title">{{translate?.report.messages.peopleWithAccess}}</div>
                        <ul class="list">
                            <li class="list-row pb-0" *ngFor="let user of selected_users; let i = index">
                                <div class="who">
                                    <p-avatar image="assets/svg/Avatar.svg" styleClass="me-2" shape="circle"></p-avatar>
                                    <span class="name">{{ user.fullName }}</span>
                                </div>

                                <div class="role">
                                    <!-- Owner is static text; others get a dropdown -->
                                    <ng-container *ngIf="folderForm.controls['access'+user.id]?.value === 'OWNER' && data.nodeInfo.accessType !== 'OWNER'; else userRoleDd">
                                        <span class="owner-badge">{{translate?.report.fields.owner.singular}}</span>
                                    </ng-container>
                                    <ng-template #userRoleDd>
                                        <p-dropdown id="picklist_folderAccess" [options]="user.folder_access" optionLabel="name"
                                            optionValue="value" optionDisabled="disabled" 
                                            formControlName="{{'access' + user.id}}" 
                                            (onChange)="onAccessChange($event, user, i)" 
                                            [showClear]="true" [placeholder]="translate?.report.messages.selectAnAccess">
                                        </p-dropdown>
                                    </ng-template>

                                    <div class="p-error text-10 mt-1" *ngIf="folderForm.controls['access'+user.id]?.touched && folderForm.controls['access'+user.id]?.invalid">
                                        <span *ngIf="folderForm.controls['access'+user.id]?.errors?.required">
                                        {{translate?.general.validationFE.requiredField}}
                                        </span>
                                    </div>
                                </div>

                                <button type="button" class="icon-btn" [pTooltip]="translate?.general.buttons.remove.singular" *ngIf="folderForm.controls['access'+user.id]?.value !== 'OWNER'" (click)="onUserDelete(user, i)">
                                    <i class="fa-regular fa-times-circle" aria-hidden="true"></i>
                                </button>
                            </li>
                        </ul>
                    </div>

                    <!-- <div class="row">
                            <div class="col-9 user-list-container" *ngIf="selected_users.length > 0">
                                <div class="font-bold mb-2">People with access</div>
                                <ul class="selected_users">
                                    <li *ngFor="let user of selected_users; let i = index">
                                        <div class="row mb-2">
                                            <div class="col-6 flex-align-center gap-2">
                                                <p-avatar image="assets/svg/Avatar.svg" styleClass="mr-2 mt-2" shape="circle"></p-avatar>
                                                <span class="name">{{user.fullName}}</span>
                                            </div>
                                            <div class="col-3">
                                                <p-dropdown id="picklist_folderAccess" 
                                                    [options]="user.folder_access" optionLabel="name" optionValue="value" optionDisabled="disabled"
                                                    formControlName="{{'access'+user.id}}" 
                                                    (onChange)="onAccessChange($event, user, i)"
                                                    [showClear]="true" [placeholder]="translate?.report.messages.selectAnAccess">
                                                </p-dropdown>

                                                <div class="p-error text-10 mt-1" *ngIf="folderForm.controls['access'+user.id].touched && folderForm.controls['access'+user.id].invalid">
                                                    <span *ngIf="folderForm.controls['access'+user.id].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                                                </div>
                                            </div>
                                            <div class="col-3 flex-align-center" *ngIf="folderForm.controls['access'+user.id].value !== 'OWNER'">
                                                <i class="fa-regular fa-circle-xmark" aria-hidden="true" (click)="onUserDelete(user, i)" [ngClass]="{'mt-neg-10px': folderForm.controls['access'+user.id].errors}"></i>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-3"></div>
                        </div> -->

                    <!-- Step 2 -->
                    <div class="section-title mt-3">
                        <span class="bullet-container"><span class="font-white fa-sm number-bullet">2</span></span>
                        <h6 class="font-bold mt-2 bullet-label">{{translate?.report.messages.whichGroupsToShareFile}} {{module}} {{translate?.report.messages.with}}</h6>
                        <i class="fa-regular fa-info-circle fa-sm" [pTooltip]="translate?.report.messages.whichGroupsToShareFileHelpText"></i>
                    </div>

                    <!-- Groups input row -->
                    <div class="row-line">
                        <div class="grow">
                            <p-multiSelect class="w-100 reports-select" [showToggleAll]="false" 
                                (onPanelHide)="onDropdownHide(panelValueGP)" [maxSelectedLabels]="6"
                                #panelValueGP
                                [options]="user_groups" display="chip" optionLabel="name" optionValue="id" formControlName="user_group" 
                                [placeholder]="translate?.report.messages.addGroupsHere" 
                                id="picklist_viewerUsersGroup" (onChange)="onGroupChange($event)">
                                
                                <!-- <ng-template pTemplate="summary" let-selectedItems let-remaining>
                                    and {{remaining}} others
                                </ng-template> -->
                            </p-multiSelect>
                            <div class="p-error text-10 mt-1" *ngIf="folderForm.controls['user_group'].touched && folderForm.controls['user_group'].invalid">
                                <span *ngIf="folderForm.controls['user_group'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                            </div>
                        </div>

                      
                    </div>


                    <!-- List of Group Access -->
                    <div class="list-block" *ngIf="selected_groups.length > 0">
                        <div class="list-title">{{translate?.report.messages.groupsWithAccess}}</div>
                        <ul class="list">
                            <li class="list-row pb-0" *ngFor="let group of selected_groups; let gi = index">
                                <div class="who">
                                    <span class="user-icon"><i class="fa fa-users" aria-hidden="true"></i></span>
                                    <span class="name">{{ group.name }}</span>
                                </div>

                                <div class="role">
                                    <p-dropdown id="picklist_folderAccess" [options]="folder_access_group" optionLabel="name" optionValue="value" formControlName="{{'access_group'+group.id}}" [showClear]="true" [placeholder]="translate?.report.messages.selectAnAccess">
                                    </p-dropdown>
                                    <div class="p-error text-10 mt-1" *ngIf="folderForm.controls['access_group'+group.id].touched && folderForm.controls['access_group'+group.id].invalid">
                                        <span *ngIf="folderForm.controls['access_group'+group.id].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                                    </div>
                                </div>

                                <button type="button" class="icon-btn" [pTooltip]="translate?.general.buttons.remove.singular" (click)="onGroupDelete(group, gi)">
                                    <i class="fa-regular fa-times-circle" aria-hidden="true"></i>
                                    <!-- <i class="fa-regular fa-circle-xmark" aria-hidden="true" (click)="onGroupDelete(group, gi)" [ngClass]="{'mt-neg-10px': folderForm.controls['access_group'+group.id].errors}"></i> -->
                                </button>
                            </li>
                        </ul>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>

    <div class="custella-modal-footer flex-align-center justify-content-end gap-2">
        <button class="custella-btn-white" (click)="onCancelClick()">{{cancelButtonLabel}}</button>
        <p-button *ngIf="!isNextButtonClicked && header == 'add'" [label]="buttonLabel" [disabled]="folderForm.controls['name'].invalid" styleClass="h-32" id="btn_Next" (onClick)="onClickNext()"></p-button>
        <p-button *ngIf="isNextButtonClicked" [label]="buttonLabel" [disabled]="folderForm.invalid" styleClass="h-32" id="btn_Next" (onClick)="onSubmit()"></p-button>
        <!-- TO BE DELETED LATER -->
        <p-button *ngIf="header == 'rename'" [label]="buttonLabel" [disabled]="folderForm.controls['name'].invalid" styleClass="h-32" id="btn_Next" (onClick)="onSubmit()"></p-button>

    </div>
</div>